


















































































































































import Vue from 'vue';

import {
  Component, Inject, Provide, Prop, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { TextBoxDatePicker } from '@kasasa/portal-components';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { KCardHeader, KCardHeaderBtn } from '@kasasa/fbase-components';
import {
  FiConfigurationResource,
} from '@/api/ficonfiguration';
import {
  ProductMapping,
  CoreAccountProduct,
} from '@/api/productmapping';

interface ProductSelectionItem {
  label: string;
  value: CoreAccountProduct | null | '';
}

interface EditableProductMapping {
  productMapping: ProductMapping;
  workingCopy: ProductMapping | null;
  editMode: boolean;
  businessChecking: boolean;
}

@Component({
  computed: mapState(['fiId', 'configVersion']),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    TextBoxDatePicker,
  },
})
export default class LinkingSheet extends Vue {
  @Prop({ default: false }) value!: boolean;

  show: boolean = false;

  @Inject('FiConfigurationResource')
  @Provide('FiConfigurationResource')
  fiConfigurationResource!: FiConfigurationResource;

  fiId!: number;

  loading: boolean = false;

  linkingData: EditableProductMapping[] = [];

  saverProducts: CoreAccountProduct[] = [];

  coreAccountProductToProductType: Map<CoreAccountProduct, string> = new Map();

  noLinkElement: any = {
    coreAccountType: 'Link',
    coreProductCode: 'No',
    linkedCoreAccountProduct: null,
  };

  ProductTypes: any = {
    INCONTROL_MULTI_LEVEL: 'InControl: Multi-Level',
    INCONTROL_QUALIFICATION: 'InControl: Qualification',
    INCONTROL_BURN_DOWN: 'InControl: Burn-Down',
    KASASA_CASH: 'Kasasa Cash',
    KASASA_CASH_BACK: 'Kasasa Cash Back',
    KASASA_REWARDS: 'Kasasa Rewards',
    KASASA_TUNES: 'Kasasa Tunes',
    KASASA_CASH_EDGE: 'Kasasa Cash + Edge',
    KASASA_CASH_BACK_EDGE: 'Kasasa Cash Back + Edge',
    KASASA_TUNES_EDGE: 'Kasasa Tunes + Edge',
    KASASA_EATS: 'Kasasa Eats',
    KASASA_STREAMING: 'Kasasa Play',
    REGULAR_CHECKING: 'Regular Checking',
    SENIOR_CHECKING: 'Senior Checking',
    STUDENT_CHECKING: 'Student Checking',
    NOW_INTEREST_CHECKING: 'NOW/Interest Checking',
    VALUE_ADDED_CHECKING: 'Value-Added Checking',
    BUSINESS_CHECKING: 'Business Checking',
    MONEY_MARKET_DEPOSIT_ACCOUNT: 'Money Market Deposit Account',
    KASASA_SAVER: 'Kasasa Saver',
    REGULAR_SAVINGS: 'Regular Savings',
    SAVINGS_529: '529 Savings',
    CD: 'CD',
    IRA_CD: 'IRA CD',
    MORTGAGE: 'Mortgage',
    MORTGAGE_MISC: 'Mortgage - Miscellaneous',
    CONSUMER_LOAN: 'Consumer Loan',
    COMMERCIAL_LOAN: 'Commercial Loan',
    HELOC: 'HELOC',
    AUTO_LOAN: 'Auto Loan',
    AUTO_LOAN_MISC: 'Auto Loan - Miscellaneous',
    CREDIT_CARD: 'Credit Card',
    STUDENT_LOAN: 'Student Loan',
    CONSUMER_LINE_OF_CREDIT: 'Consumer Line of Credit',
    COMMERCIAL_LINE_OF_CREDIT: 'Commercial Line of Credit',
    BUSINESS_REWARD_CHECKING: 'Business Reward Checking',
    BUSINESS_REAL_CASH_BACK: 'Business Real Cash Back',
    BUSINESS_REAL_SAVER: 'Business Real Saver',
  };

  currentObject: any;

  changeDropDown = (
    selected: CoreAccountProduct,
    parent: CoreAccountProduct,
  ) => {
    /* eslint-disable no-param-reassign */
    parent.linkedCoreAccountProduct = selected;
    /* eslint-enable no-param-reassign */
  };

  saving: boolean = false;

  @Watch('value')
  onNewValue() {
    this.show = this.value;
    if (this.show) {
      this.loadData();
    }
  }

  loadData() {
    this.loading = true;
    this.fiConfigurationResource
      .getProductMapping(this.fiId)
      .then((res: ProductMapping[]) => {
        this.linkingData = this.getDdaProductMappingsAndSetModelToNoLinkIfApplicable(
          res,
        );

        this.saverProducts = this.getSaverCoreAccountProducts(res);
      })
      .catch((err) => {
        this.showError(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onShowToggle(newValue: boolean) {
    this.show = newValue;
    this.$emit('input', this.show);
  }

  getSaverCoreAccountProducts(
    productMappings: ProductMapping[],
  ): CoreAccountProduct[] {
    this.coreAccountProductToProductType.clear();

    const parent: LinkingSheet = this;
    const saverProductMappings: ProductMapping[] = productMappings.filter(
      (productMapping: ProductMapping) => parent.ProductTypes[productMapping.productType!]
        === parent.ProductTypes.KASASA_SAVER
        || parent.ProductTypes[productMapping.productType!]
        === parent.ProductTypes.BUSINESS_REAL_SAVER,
    );

    const saverCoreAccountProducts: CoreAccountProduct[] = [];
    saverProductMappings.forEach((saverProductMapping) => {
      saverProductMapping.coreAccountProductTypes.forEach(
        (saverCoreAccountProduct: CoreAccountProduct) => {
          saverCoreAccountProducts.push(saverCoreAccountProduct);
          this.coreAccountProductToProductType.set(saverCoreAccountProduct, saverProductMapping.productType!);
        },
      );
    });
    return saverCoreAccountProducts;
  }

  getDdaProductMappingsAndSetModelToNoLinkIfApplicable(
    productMappings: ProductMapping[],
  ): EditableProductMapping[] {
    const ddaProductMappings: ProductMapping[] = productMappings.filter(
      (productMapping: ProductMapping) => this.ProductTypes[productMapping.productType!]
        === this.ProductTypes.KASASA_CASH
        || this.ProductTypes[productMapping.productType!]
        === this.ProductTypes.KASASA_CASH_BACK
        || this.ProductTypes[productMapping.productType!]
        === this.ProductTypes.KASASA_REWARDS
        || this.ProductTypes[productMapping.productType!]
        === this.ProductTypes.KASASA_EATS
        || this.ProductTypes[productMapping.productType!]
        === this.ProductTypes.KASASA_STREAMING
        || this.ProductTypes[productMapping.productType!]
        === this.ProductTypes.BUSINESS_REWARD_CHECKING
        || this.ProductTypes[productMapping.productType!]
        === this.ProductTypes.BUSINESS_REAL_CASH_BACK,
    );

    const editableMappings: EditableProductMapping[] = [];
    ddaProductMappings.forEach((productMapping: ProductMapping) => {
      const isBusinessCheckingProduct: boolean = this.isBusinessCheckingProduct(productMapping.productType!);
      productMapping.coreAccountProductTypes.forEach(
        (coreAccountProduct: CoreAccountProduct) => {
          if (this.wasPreviouslySetToNoLink(coreAccountProduct)) {
            /* eslint-disable no-param-reassign */
            coreAccountProduct.linkedCoreAccountProduct = null;
            /* eslint-enable no-param-reassign */
          }
        },
      );
      editableMappings.push({
        productMapping,
        workingCopy: null,
        editMode: false,
        businessChecking: isBusinessCheckingProduct,
      });
    });

    return editableMappings;
  }

  wasPreviouslySetToNoLink = (coreAccountProduct: CoreAccountProduct) => coreAccountProduct.isCurrentlyLinked === false;

  openEditMode(current: EditableProductMapping) {
    this.linkingData.forEach((item: any) => {
      /* eslint-disable no-param-reassign */
      item.editMode = false;
      /* eslint-enable no-param-reassign */
    });

    /* eslint-disable no-param-reassign */
    current.workingCopy = { ...current.productMapping };
    current.editMode = true;
    /* eslint-enable no-param-reassign */
  }

  getCurrentlySelectedSaverProductsByProductTypeExceptForSelectedByCoreAccountProduct(
    coreAccountProduct: CoreAccountProduct,
    productType: string,
  ): CoreAccountProduct[] {
    const selectedSaverProducts: CoreAccountProduct[] = [];
    const isBusinessChecking: boolean = this.isBusinessCheckingProduct(productType);

    this.linkingData
      .filter(
        (editableMapping: EditableProductMapping) => editableMapping.productMapping.productType === productType,
      )
      .filter(
        (editableMapping: EditableProductMapping) => editableMapping.businessChecking === isBusinessChecking,
      )
      .forEach((ddaProductMapping: EditableProductMapping) => {
        let coreAccountProductTypes;
        if (ddaProductMapping.editMode && ddaProductMapping.workingCopy) {
          coreAccountProductTypes = ddaProductMapping.workingCopy.coreAccountProductTypes;
        } else {
          coreAccountProductTypes = ddaProductMapping.productMapping.coreAccountProductTypes;
        }

        coreAccountProductTypes.forEach(
          (ddaCoreAccountProduct: CoreAccountProduct) => {
            if (
              ddaCoreAccountProduct.linkedCoreAccountProduct !== null
              && !this.coreAccountProductsEqual(
                ddaCoreAccountProduct,
                coreAccountProduct,
              )
            ) {
              selectedSaverProducts.push(
                ddaCoreAccountProduct.linkedCoreAccountProduct,
              );
            }
          },
        );
      });

    return selectedSaverProducts;
  }

  getSaversExceptCurrentlySelected(
    productMapping: ProductMapping,
    coreAccountProduct: CoreAccountProduct,
  ): ProductSelectionItem[] {
    const selectedSaverCoreAccountProducts: CoreAccountProduct[] = this.getCurrentlySelectedSaverProductsByProductTypeExceptForSelectedByCoreAccountProduct(
      coreAccountProduct,
      productMapping.productType!,
    );
    const allowableToSelect: CoreAccountProduct[] = this.getSaverCoreAccountProductsAvailableForSelect(
      selectedSaverCoreAccountProducts,
      productMapping,
    );

    const selectionItems: ProductSelectionItem[] = [];

    selectionItems.push({
      label: 'No-Link',
      value: null,
    });

    allowableToSelect
      .forEach((product: CoreAccountProduct) => {
        selectionItems.push({
          label: `${product.coreProductCode}-${product.coreAccountType}`,
          value: product,
        });
      });

    return selectionItems;
  }

  getSaverCoreAccountProductsAvailableForSelect(
    selectedSaverCoreAccountProducts: CoreAccountProduct[],
    productMapping: ProductMapping,
  ): CoreAccountProduct[] {
    return this.saverProducts
      .filter((item: CoreAccountProduct) => {
        const productType: string = this.coreAccountProductToProductType.get(item)!;
        const isBusinessProduct = this.isBusinessCheckingProduct(productMapping.productType!);
        const isBusinessSavings = this.isBusinessSaverProduct(productType);
        return isBusinessProduct === isBusinessSavings;
      })
      .filter((saverCoreAccountProduct: any) => {
        let saverAlreadySelected = false;
        selectedSaverCoreAccountProducts.forEach(
          (selectedSaverProduct: CoreAccountProduct) => {
            if (
              this.coreAccountProductsEqual(
                selectedSaverProduct,
                saverCoreAccountProduct,
              )
            ) {
              saverAlreadySelected = true;
            }
          },
        );
        return !saverAlreadySelected;
      });
  }

  coreAccountProductsEqual(
    coreAccountProduct1: CoreAccountProduct,
    coreAccountProduct2: CoreAccountProduct,
  ) {
    const sameCodeAndType = coreAccountProduct1.coreProductCode!
      + coreAccountProduct1.coreAccountType
      === coreAccountProduct2.coreProductCode! + coreAccountProduct2.coreAccountType;
    const product1Unlinked = this.coreAccountProductIsSetToUnlinkedItem(
      coreAccountProduct1,
    );
    const product2Unlinked = this.coreAccountProductIsSetToUnlinkedItem(
      coreAccountProduct2,
    );
    return sameCodeAndType && product1Unlinked === product2Unlinked;
  }

  coreAccountProductIsSetToUnlinkedItem = (coreAccountProduct: CoreAccountProduct) => coreAccountProduct.linkedCoreAccountProduct !== undefined
    && coreAccountProduct.linkedCoreAccountProduct !== null

  saveItem(item: EditableProductMapping) {
    this.saving = true;
    if (item.workingCopy) {
      item.workingCopy.coreAccountProductTypes.forEach(
        (product: CoreAccountProduct) => {
          if (product.linkedCoreAccountProduct) {
            /* eslint-disable no-param-reassign */
            product.isCurrentlyLinked = true;
            /* eslint-enable no-param-reassign */
          } else if (product.linkedCoreAccountProduct === '' || product.linkedCoreAccountProduct === null) {
            /* eslint-disable no-param-reassign */
            product.isCurrentlyLinked = false;
            /* eslint-enable no-param-reassign */
          }
        },
      );
      this.fiConfigurationResource
        .updateProduct(this.fiId, item.workingCopy.id!, item.workingCopy)
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.saving = false;
          /* eslint-disable no-param-reassign */
          item.editMode = false;
          /* eslint-enable no-param-reassign */
        });
    }
  }

  showError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  isBusinessCheckingProduct = (productType: string): boolean => productType === 'BUSINESS_REWARD_CHECKING' || productType === 'BUSINESS_REAL_CASH_BACK'

  isBusinessSaverProduct = (productType: string): boolean => productType === 'BUSINESS_REAL_SAVER'
}
